import * as $ from "jquery";
import * as _ from "lodash";
import { AppWidgetCollection } from "../../../../collections/AppWidgets";
import { DashboardCategoryCollection } from "../../../../collections/DashboardCategories";
import { DashboardWidgetCollection } from "../../../../collections/DashboardWidgets";
import { DashboardTabCollection } from "../../../../collections/DashboardTabs";
import { ModuleCollection } from "../../../../collections/Modules";
import { DashboardWidget } from "../../../../models/DashboardWidget";
import { User } from "../../../../models/User";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../../_BaseModifyModal";
import { ModifyModuleLayoutWidget } from "../../dashboard/modify_widgets/layout/ModifyModuleLayoutWidget";
import { ModifyMultiGaugeWidget } from "../../dashboard/modify_widgets/multigauge/ModifyMultiGaugeWidget";
import { ModifyAggregateTableWidgetView } from "../../reports/modify_widgets/ModifyAggregateTableWidgetView";
import { ModifyCSVDataWidgetView } from "../../reports/modify_widgets/ModifyCSVDataWidgetView";
import { ModifyDateTimeWidgetView } from "../../reports/modify_widgets/ModifyDateTimeWidgetView";
import { ModifySignatureWidgetView } from "../../reports/modify_widgets/ModifySignatureWidgetView";
import { ModifyTextWidgetView } from "../../reports/modify_widgets/ModifyTextWidgetView";
import { ModifyTitleWidgetView } from "../../reports/modify_widgets/ModifyTitleWidgetView";
import { ModifyTotalWidgetView } from "../../reports/modify_widgets/ModifyTotalWidgetView";
import { BaseModifyDashboardWidgetView } from "./_BaseModifyWidgetView";
import { ModifyChartWidgetView } from "./chart/ModifyChartWidgetView";
import { ModifyDefaultChartWidgetView } from "./genericnooptions/defaultchartwidget/DefaultChart";
import { ModifyIAQWidgetView } from "./iaq/IAQWidget";
import { ModifyLobbyViewWidget } from "./lobbyview/ModifyLobbyViewWidget";
import { ModifySensitivityWidget } from "./sensitivity/ModifySensitivityWidget";
import { ModifySimpleWidgetView } from "./simplewidget/SimpleWidget";
import { ModifyTableWidgetView } from "./table/ModifyTableWidgetView";
import { ModifyIframeWidgetView } from "./iframe/ModifyIframeWidgetView";


declare var App: any;

interface ModifyDashboardWidgetModalOptions extends BaseModifyModalViewOptions {
    dashboardWidgetCollection: DashboardWidgetCollection;
    dashboardCategoryCollection: DashboardCategoryCollection;
    dashboardTabCollection?: DashboardTabCollection;
    moduleCollections: { [key: number]: ModuleCollection };
    dashboardId: number;
    widget: DashboardWidget;
    categoryId?: number;
    validWidgets: number[];
    report?: Backbone.Model;
    currentUser: User;
    activeTabId?: number | null;
}

export class ModifyDashboardWidgetModal extends BaseModifyModalView {

    options: ModifyDashboardWidgetModalOptions;
    private template = _.template(require('templates/modals/dashboard/modify_widgets/modifyWidget.html'));
    private bodyTemplate = _.template(require('templates/modals/dashboard/modify_widgets/modifyWidgetBody.html'));
    private appWidgets = new AppWidgetCollection();
    private subview: BaseModifyDashboardWidgetView;
    private savable = true;

    constructor(options: ModifyDashboardWidgetModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #addDashboardWidgetModal': 'handleModalShown',
                'hidden.bs.modal #addDashboardWidgetModal': 'handleModalHidden',
                'click .category > .title': 'handleCategoryClick',
                'input .categories > .filter': 'handleFilterChange',
                'click .modal-footer .back': 'renderBody',
                'click .modal-footer .save': 'saveWidget',
                'click .item': 'handleAppTypeClick',
                'click .tab-button': 'handleTabClick'
        }
        }, options));

        // For the base class methods
        this.modalIdSelector = 'addDashboardWidgetModal';
    }

    render() {
        this.$el.html(this.template({
            widget: this.options.widget,
            cat: this.options.categoryId
        }));
        this.renderBody();
        return this;
    }

    private renderBody() {
        this.$('.modal-footer .back').addClass('hidden');
        this.$('.modal-footer .save').addClass('hidden');

        if (this.subview) this.subview.remove();

        var isCsvReport = (this.options.report && this.options.report.get('format') === 'csv');
        var isCSVDataReport = (this.options.report && this.options.report.get('format') === 'csv_data');
        $.when(this.appWidgets.fetch({ reset: true })).done(() => {
            if (isCsvReport) {
                // Reports with CSV format can only add a table widget or an aggregate table widget
                this.appWidgets.models = this.appWidgets.models.filter((w) => {
                    const widgetID = w.get('id');
                    return widgetID === 9 || widgetID === 19;
                });
            } else if(isCSVDataReport) {
                // Reports with csv_data format can only add a csv data widget
                this.appWidgets.models = this.appWidgets.models.filter((w) => {
                    const widgetID = w.get('id');
                    return widgetID === 20;
                });
            } else if (this.options.report) {
                // Include only widgets that are valid for reports
                this.appWidgets.models = this.appWidgets.filter((w) => _.includes(this.options.validWidgets, w.get('id')));
            } else if (_.size(this.appWidgets)) {
                // Include only widgets that are valid for regular dashboards
                this.appWidgets.models = this.appWidgets.filter((w) => _.includes(this.options.validWidgets, w.get('id')));
            }

            // Only allow a default chart to be created if there isn't already one on the dashboard
            var defaultChart = this.options.dashboardWidgetCollection.find((w) => {
                return w.get('dashboard_widget_type_id') === 4
            });
            if (defaultChart) {
                this.appWidgets.models = this.appWidgets.filter((w) => {
                    return w.get('id') !== 4;
                });

            }
            this.$('.modal-body').html(this.bodyTemplate({
                appWidgets: this.appWidgets
            }));

            if (this.options.widget) {
                var widgetTypeModel = this.appWidgets.findWhere({
                    id: this.options.widget.get('dashboard_widget_type_id')
                });
                this.renderSubView(widgetTypeModel);
            }
        });

        // Set modal title
        var titleText = this.options.report ? 'Add a Widget to this Report' : 'Add a new Widget';
        this.$('h4.modal-title').text(titleText);
    }

    private renderSubView(widgetTypeModel) {
        var deferred = $.Deferred();

        // Make sure by default the widget is savable
        this.setSavable(true);
        var widgetTypeId = widgetTypeModel.get('id');

        // Ensure tab collection is fetched if it exists
        var tabCollectionPromise: any = $.Deferred().resolve();
        if (this.options.dashboardTabCollection) {
            // Force fetch to ensure collection is loaded
            tabCollectionPromise = this.options.dashboardTabCollection.getCollectionFetchPromise();
        } else {
            // If no collection provided, try to create one
            if (this.options.dashboardId) {
                var DashboardTabCollection = require('../../../../collections/DashboardTabs').DashboardTabCollection;
                this.options.dashboardTabCollection = new DashboardTabCollection([], { dashboardId: this.options.dashboardId });
                tabCollectionPromise = this.options.dashboardTabCollection.getCollectionFetchPromise();
            }
        }

        // Determine current tab ID from widget's category or use active tab as default
        var currentTabId = null;
        if (this.options.widget && !this.options.widget.isNew()) {
            var widgetCategory = this.options.dashboardCategoryCollection.findWhere({
                id: this.options.widget.get('dashboard_category_id')
            });
            if (widgetCategory) {
                currentTabId = widgetCategory.get('dashboard_tab_id');
            }
        } else if (this.options.categoryId) {
            var category = this.options.dashboardCategoryCollection.findWhere({
                id: this.options.categoryId
            });
            if (category) {
                currentTabId = category.get('dashboard_tab_id');
            }
        }
        
        // If no tab ID found, use the active tab from the dashboard view
        if (currentTabId === null && this.options.activeTabId !== undefined) {
            currentTabId = this.options.activeTabId;
        }

        // Wait for tab collection to be fetched before proceeding
        $.when(tabCollectionPromise).done(() => {

        var modifyViewOptions = {
            appCollection: this.options.appCollection,
            installCollection: this.options.installCollection,
            permissionCollection: this.options.permissionCollection,
            organizationCollection: this.options.organizationCollection,
            dashboardCollection: this.options.dashboardCollection,
            dashboardChannelCollection: this.options.dashboardChannelCollection,
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            dashboardWidgetCollection: this.options.dashboardWidgetCollection,
            moduleCollections: this.options.moduleCollections,
            dashboardId: this.options.dashboardId,
            widget: this.options.widget,
            parentView: this,
            widgetTypeId: widgetTypeId,
            widgetType: widgetTypeModel.get('type'),
            appTypeId: widgetTypeModel.get('app_type_id'),
            appType: widgetTypeModel.get('app_type'),
            categoryId: this.options.categoryId,
            tabId: currentTabId,
            currentUser: this.options.currentUser,
            report: this.options.report
        };

        var title: string;
        if (this.options.widget) {
            title = 'Modify ' + widgetTypeModel.get('name');
        } else {
            title = "Add a " + widgetTypeModel.get('name');
        }

        var view;
        // Determine which kind of widget view should be displayed in the modal
        switch (widgetTypeId) {
            case 1:
                view = new ModifySimpleWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 3:
                view = new ModifyChartWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 4:
                view = new ModifyDefaultChartWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 8:
                view = new ModifyIAQWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 9:
                view = new ModifyTableWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 10:
                view = new ModifyTitleWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 11:
                view = new ModifyTextWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 12:
                view = new ModifySignatureWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 13:
                view = new ModifyTotalWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 14:
                view = new ModifyModuleLayoutWidget(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 15:
                view = new ModifyMultiGaugeWidget(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 16:
                view = new ModifySensitivityWidget(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 17:
                view = new ModifyLobbyViewWidget(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 18:
                view = new ModifyDateTimeWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 19:
                view = new ModifyAggregateTableWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 20:
                view = new ModifyCSVDataWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            case 21:
                view = new ModifyIframeWidgetView(modifyViewOptions);
                view.ensureCollectionLoaded().done(() => {
                    deferred.resolve(view);
                });
                break;
            default:
                this.options.appRegistry.getInstance(widgetTypeModel.get('app_type'), (err, app) => {
                    deferred.resolve(app.getWidgetModifyViewByTypeId(widgetTypeId, modifyViewOptions));
                });
                break;
        }

            // Render the ModifyDashboardWidget View
            $.when(deferred).done((view) => {
                this.$('.modal-body').empty().append(view.$el);
                view.render();

                this.$('h4.modal-title').text(title);

                this.$('.modal-footer .back').removeClass('hidden');
                this.$('.modal-footer .save').removeClass('hidden').prop('disabled', !this.savable);

                view.show();
                this.subview = view;

                // Provide a default category where widgets can be created in brand-new dashboards
                // There should only ever be one category on a reports dashboard
                var categories = this.options.dashboardCategoryCollection;
                var numberOfCategories = this.options.report ? 1 : 2;
                if (_.size(categories) < numberOfCategories) {
                    this.$('.category select').append($('<option>', {
                        text: 'All Widgets'
                    }));
                }
            });
        });

        return this;
    }

    setSavable(savable) {
        this.savable = savable;
        this.$('.modal-footer .save').prop('disabled', !savable);
    }

    setLoading() {
        this.$('.modal-footer .buttons').addClass('hidden');
        this.$('.modal-footer .spinner-container').removeClass('hidden');
    }

    private createCategoryIfNecessary(categoryId: number, categoryName: string) {
        // If category Id is a number, it already exists. If it is a string create a new category
        var deferred = $.Deferred();
        // Don't create more than one category for a report
        if (!categoryId && !this.options.report) {
            var categories = this.options.dashboardCategoryCollection.where({ minimal: 0 });

            var order;
            if (!_.size(categories)) {
                // If this is a brand-new dashboard with no categories, make it the first one
                order = 1;
            } else {
                // Otherwise, order it according to the existing categories
                order = _.maxBy(categories, (c) => {
                    return c.get('order')
                }).get('order') + 1;
            }

            // Get tabId from subview (user selection) or from collection
            var tabId = this.subview ? this.subview.getTabId() : this.options.dashboardCategoryCollection.tabId;
            if (tabId === null && this.subview && this.subview.options.tabId !== undefined) {
                tabId = this.subview.options.tabId;
            }

            var requestData: any = {
                name: categoryName,
                dashboardId: this.options.dashboardId,
                order: order
            };
            
            // Include tabId if available
            if (tabId !== undefined && tabId !== null) {
                requestData.tabId = tabId;
            }

            $.when($.ajax({
                type: "POST",
                url: this.options.dashboardCategoryCollection.url(),
                data: JSON.stringify(requestData),
                dataType: 'json',
                contentType: "application/json; charset=utf-8"
            })).done((response) => {
                deferred.resolve(response.categoryId);
            });

            return deferred
        } else if (categoryId) {
            return deferred.resolve(categoryId)
        }
    }

    setParams() {
        var aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
            return $(type).val();
        });

        if (this.options.widget) {
            this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        }

        return true;
    }

    private saveWidget() {
        var widget = this.subview.options.widget;
        var initialCategory = widget.get('dashboard_category_id');
        var shouldSave = this.subview.preSave();

        if (!shouldSave) {
            // return this.hide();
            return; // Don't close the modal, just return
            
        }

        var widgetChannels = this.options.dashboardChannelCollection.where({
            dashboard_widget_id: widget.get('id')
        });
        var categoryId = this.subview.getCategoryId();
        var categoryName = this.subview.getCategoryName();
        if (widget.isNew()) {
            this.options.dashboardWidgetCollection.add(widget);
        }

        this.setLoading();

        // TODO: this should not live in here if it's specific to report widgets
        if (this.options.report && widget.get('dashboard_widget_type_id') === 13) {
            // Total widgets need params for aggregation function, period, dates, etc.
            this.setParams();
        }

        App.Bus.trigger('dashboard:update:suspend');
        _.each(widgetChannels, (ch) => {
            var dashboardChannelId = ch.get('dashboard_channel_id');
            if (categoryId) App.Bus.trigger('dashboard:category:' + categoryId + ':chart:removeChannel', dashboardChannelId);
            App.Bus.trigger('dashboard:category:all:chart:removeChannel', dashboardChannelId);
        });
        var mustPostSave = false;
        var tabId = this.subview ? this.subview.getTabId() : null;
        var resolvedCategoryId;
        $.when(this.createCategoryIfNecessary(categoryId, categoryName))
            .then((categoryId) => {
                resolvedCategoryId = categoryId;
                // If tab changed, update the category's tab_id
                if (categoryId && tabId !== null && tabId !== undefined) {
                    var category = this.options.dashboardCategoryCollection.findWhere({ id: categoryId });
                    if (category && category.get('dashboard_tab_id') !== tabId) {
                        // Update category's tab_id via API
                        return $.ajax({
                            type: "PUT",
                            url: `/api/v1/dashboards/${this.options.dashboardId}/categories/${categoryId}`,
                            data: JSON.stringify({
                                name: category.get('name'),
                                widget_ui_positions: category.get('widget_ui_positions'),
                                tabId: tabId
                            }),
                            dataType: 'json',
                            contentType: "application/json; charset=utf-8"
                        }).then(() => {
                            // Refresh category collection to get updated tab_id
                            return this.options.dashboardCategoryCollection.fetch().then(() => {
                                return categoryId;
                            });
                        });
                    }
                }
                return categoryId;
            })
            .then((categoryId) => {
                widget.set('type_id', this.subview.options.widgetTypeId);
                widget.set('type', this.subview.options.widgetType);
                widget.set('app_type', this.subview.options.appType);
                widget.set('app_type_id', this.subview.options.appTypeId);
                // Defer tab move for sensitivity widget so postSave has channels in collection (save params first, then move)
                var deferMove = this.subview instanceof ModifySensitivityWidget && initialCategory != null && resolvedCategoryId !== initialCategory;
                var effectiveCategoryId = deferMove ? initialCategory : (resolvedCategoryId ? Number(resolvedCategoryId) : this.options.dashboardCategoryCollection.first().get('id'));
                widget.set('dashboard_category_id', effectiveCategoryId);
                widget.set('order', this.subview.getWidgetOrder());
                return widget.save();
            })
            .then(() => {
                return this.options.dashboardWidgetCollection.fetch();
            })
            .then(() => {
                var diff = this.subview.getChannelDifference();
                // Resolve immediately if there is nothing to do
                if (!(<any[]>diff[0]).length && !(<any[]>diff)[2].length && _.isEmpty(diff[1])) {
                    return $.Deferred().resolve().promise();
                }

                return $.ajax({
                    type: "PUT",
                    url: this.options.dashboardChannelCollection.url(),
                    data: JSON.stringify({
                        'delete': diff[2],
                        create: diff[0],
                        update: diff[1]
                    }),
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                })
            })
            .then(() => {
                return this.options.dashboardChannelCollection.fetch();
            })
            .then(() => {
                // Ensure widget reference is the one in the collection so postSave's widget.save() has a url
                var widgetId = this.subview.options.widget.get('id');
                if (widgetId) {
                    var fromCollection = this.options.dashboardWidgetCollection.get(widgetId);
                    if (fromCollection) this.subview.options.widget = fromCollection;
                }
                mustPostSave = this.subview.postSave();
                return mustPostSave;
            })
            .then(() => {
                return mustPostSave ? this.options.dashboardWidgetCollection.fetch() : $.Deferred().resolve();
            })
            .then(() => {
                return mustPostSave ? this.options.dashboardChannelCollection.fetch() : $.Deferred().resolve();
            })
            .then(() => {
                // Deferred move for sensitivity widget: save params first, then move (so postSave had channels in collection)
                if (this.subview instanceof ModifySensitivityWidget && initialCategory != null && resolvedCategoryId !== initialCategory) {
                    var w = this.subview.options.widget;
                    w.set('dashboard_category_id', resolvedCategoryId ? Number(resolvedCategoryId) : this.options.dashboardCategoryCollection.first().get('id'));
                    return w.save()
                        .then(() => this.options.dashboardWidgetCollection.fetch())
                        .then(() => this.options.dashboardChannelCollection.fetch());
                }
                return $.Deferred().resolve();
            })
            .then(() => {
                _.each(_.uniq(_.filter([initialCategory, resolvedCategoryId])), (id) => {
                    App.Bus.trigger('dashboard:category:' + id + ':layout');
                });
                App.Bus.trigger('dashboard:config:changed');
                App.Bus.trigger('dashboard:update:resume');

                this.hide();
                // If it is a new category rerender
                if (!resolvedCategoryId || this.subview.options.widgetTypeId == 17) {
                    this.reloadUrl();
                }
            })
            .fail((err: any) => {
                // Remove loading state
                this.$('.modal-footer .buttons').removeClass('hidden');
                this.$('.modal-footer .spinner-container').addClass('hidden');

                // Log so we can see what actually failed
                console.error('Widget save failed:', err && err.responseJSON ? err.responseJSON : (err && err.message ? err.message : err));

                if (err.responseJSON != null && err.responseJSON.code == 'INVALID RANGES') {
                    // Get channel/dashboard channel id
                    var elementId = err.responseJSON.elementId;
                    var title = err.responseJSON.message;

                    (<any>$).notify({
                        title: title,
                        message: "Check ranges on highlighted channel",
                        icon: 'fa fa-exclamation-circle',
                    }, {
                        animate: {
                            enter: 'animated fadeInUp',
                        },
                        // The type property defines the css style
                        // See alerts.less for available styles
                        type: "warning-alt",
                        placement: { from: "bottom", align: "center" }
                    });

                    // Highlight the channel with the error
                    // IAQ has a different layout than every other type of widget
                    if (this.subview.options.widgetTypeId == 8) {
                        _.each($('.channel-thresholds'), (channelRow) => {
                            $(channelRow).css('background-color', '');
                            $(`[data-dashboard-channel-id='${elementId}']`).css('background-color', '#ffe6ce82');
                            $(`[data-channel-id='${elementId}']`).css('background-color', '#ffe6ce82');
                        });
                    } else {
                        _.each($('.channel-selects'), (row) => {
                            var value = $(row).find('.widget-dashboard-channel-id').val();
                            if (!value) value = $(row).find('.widget-channel-select-channel').val();
                            if (value == elementId) {
                                $(row).css('background-color', '#ffe6ce82');
                            } else {
                                $(row).css('background-color', '');
                            }
                        });
                    }
                } else {
                    // Show default error message
                    (<any>$).notify({
                        title: 'Could not save widget',
                        message: '',
                        icon: 'fa fa-exclamation-circle',
                    }, {
                        animate: {
                            enter: 'animated fadeInUp',
                        },
                        // The type property defines the css style
                        // See alerts.less for available styles
                        type: "danger-alt",
                        placement: { from: "bottom", align: "center" }
                    });
                }
            });
    }

    remove() {
        if (this.subview) {
            // Remove elements generated by Spectrum Color Picker
            var colorPickerInputs = $('.threshold-range .threshold-color.color-picker');
            _.each(colorPickerInputs, (cp) => {
                var $cp = $(cp);
                (<any>$cp).spectrum("container").remove();
            });
            this.subview.remove();
        }
        return super.remove();
    }

    handleModalShown() {
        if (this.subview && this.subview.show) {
            this.subview.show();
        }
    }

    private handleAppTypeClick(e: JQuery.UIEventBase) {
        var widget = this.appWidgets.findWhere({ id: Number($(e.currentTarget).attr('data-widget-type-id')) });
        this.renderSubView(widget);
    }

    private handleCategoryClick(e: JQuery.UIEventBase) {
        var cat = $(e.currentTarget);

        var caret = cat.find('i.fa');
        var typesContainer = cat.siblings('.items');

        var shown = !typesContainer.hasClass('hidden');
        if (shown) {
            typesContainer.addClass('hidden');
            caret.addClass('fa-angle-right');
            caret.removeClass('fa-angle-down');
        } else {
            typesContainer.removeClass('hidden');
            caret.removeClass('fa-angle-right');
            caret.addClass('fa-angle-down');
        }
    }

    private handleFilterChange(e: JQuery.UIEventBase) {
        var view = this;
        var val = (<string>$(e.currentTarget).val()).toLowerCase();

        // Handle original category list (keeping for backward compatibility)
        this.$('.category').each(function () {
            var categoryEl = $(this);

            var showCategory = false;
            categoryEl.find('.item').each(function () {
                var appTypeEl = $(this);
                var id = Number(appTypeEl.attr('data-widget-type-id'));
                var appType = view.appWidgets.findWhere({ id: id });

                if (appType.get('desc').toLowerCase().indexOf(val) !== -1
                    || appType.get('category').toLowerCase().indexOf(val) !== -1
                    || appType.get('name').toLowerCase().indexOf(val) !== -1) {

                    showCategory = true;
                    appTypeEl.removeClass('hidden');
                } else {
                    appTypeEl.addClass('hidden');
                }
            });

            if (showCategory) {
                categoryEl.removeClass('hidden');
            } else {
                categoryEl.addClass('hidden');
            }
        });

        // Handle Tailwind tabbed interface
        this.$('.tab-panel').each(function () {
            var panelEl = $(this);
            var showPanel = false;
            
            panelEl.find('.item').each(function () {
                var itemEl = $(this);
                var id = Number(itemEl.attr('data-widget-type-id'));
                var appType = view.appWidgets.findWhere({ id: id });

                if (appType && (appType.get('desc').toLowerCase().indexOf(val) !== -1
                    || appType.get('category').toLowerCase().indexOf(val) !== -1
                    || appType.get('name').toLowerCase().indexOf(val) !== -1)) {

                    showPanel = true;
                    itemEl.removeClass('tw-hidden');
                } else {
                    itemEl.addClass('tw-hidden');
                }
            });

            if (showPanel) {
                panelEl.removeClass('tw-hidden');
            } else {
                panelEl.addClass('tw-hidden');
            }
        });
    }

    private handleTabClick(e: JQuery.UIEventBase) {
        const $clickedTab = $(e.currentTarget);
        const category = $clickedTab.attr('data-category');
        
        // Update tab button states
        this.$('.tab-button').each(function() {
            const $tab = $(this);
            $tab.attr('data-tab-active', 'false');
            $tab.removeClass('tw-border-attune-600 tw-bg-blue-100').addClass('tw-border-transparent tw-bg-transparent hover:tw-bg-gray-100');
        });
        
        // Activate clicked tab
        $clickedTab.attr('data-tab-active', 'true');
        $clickedTab.removeClass('tw-border-transparent tw-bg-transparent hover:tw-bg-gray-100').addClass('tw-border-attune-600 tw-bg-blue-100');
        
        // Show corresponding tab panel
        this.$('.tab-panel').addClass('tw-hidden');
        this.$(`.tab-panel[data-category="${category}"]`).removeClass('tw-hidden');
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/ModifyDashboardWidgetModal.ts